/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type sprintsCompletedComponent_viewer$ref: FragmentReference;
declare export opaque type sprintsCompletedComponent_viewer$fragmentType: sprintsCompletedComponent_viewer$ref;
export type sprintsCompletedComponent_viewer = {|
  +insightComponentsData: ?{|
    +sprintsCompleted: ?{|
      +doneSprints: ?number,
      +remainingSprints: ?number,
    |}
  |},
  +$refType: sprintsCompletedComponent_viewer$ref,
|};
export type sprintsCompletedComponent_viewer$data = sprintsCompletedComponent_viewer;
export type sprintsCompletedComponent_viewer$key = {
  +$data?: sprintsCompletedComponent_viewer$data,
  +$fragmentRefs: sprintsCompletedComponent_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shareKey",
      "type": "String"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId",
      "type": "ID"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isProjectGroupType",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "sprintsCompletedComponent_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "shareKey",
          "variableName": "shareKey"
        }
      ],
      "concreteType": "InsightComponentsDataType",
      "kind": "LinkedField",
      "name": "insightComponentsData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "isProjectGroupType",
              "variableName": "isProjectGroupType"
            },
            {
              "kind": "Variable",
              "name": "projectId",
              "variableName": "projectId"
            }
          ],
          "concreteType": "SprintsCompleted",
          "kind": "LinkedField",
          "name": "sprintsCompleted",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "doneSprints",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "remainingSprints",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
// prettier-ignore
(node/*: any*/).hash = '98f9b97b926d747816cddca74e45dd00';

module.exports = node;
